"use strict";

module.exports = function(angularModule) {
  angularModule.service("accountSettingsModal", function($uibModal, RGSenderConfigService, $timeout, reactContainer) {

    this.open = function() {
      let modalInstance = $uibModal.open({
        controller: ['$scope','$uibModalInstance', function($scope, $uibModalInstance) {
          var vm = this;
          vm.loading = false;

          var initConfig = function(config) {
            vm.config = config;
            vm.emailStatus = config.fromAddressVerificationStatus;
            vm.senderName = config.senderName;
            vm.customSenderEmailAddresses = config.customSenderEmailAddresses || []
            vm.customSenderEmailAddresses.forEach(address => {
              address.isEmailValidated = (address.verificationStatus == 'Success')
            })

            vm.securityDefaults = angular.copy(config.securityDefaults);
            vm.privacyPolicyUrl = config.privacyPolicyUrl || '';
            vm.privacyPolicyUrlClean = config.privacyPolicyUrl || '';
            vm.hideLocationText = config.hideLocationText || false;
            vm.hideLocationTextClean = config.hideLocationText || false;
            vm.customFooter = config.customFooter || '';
            vm.customFooterClean = config.customFooter || '';

            // temp, for testing
            window.securityConfig = vm.securityDefaults;

            vm.loading = false;
            if (vm.deliveryConfigForm) {
              vm.deliveryConfigForm.$setPristine();
            }

            if(vm.emailSettingsForm) {
              vm.emailSettingsForm.$setPristine();
            }

            //clear up new sender address form state
            vm.newFromAddress = null
            vm.newSenderName = null
            vm.isFormVisible = false

            vm.hasDefaultEmail = false
            if (vm.config.customSenderEmailAddresses) {
              if (vm.config.customSenderEmailAddresses.find(address => address.isDefault))
                vm.hasDefaultEmail = true
            }
          };

          modalInstance.opened.then(() => {
            RGSenderConfigService.getConfig().then(initConfig);
          })


          vm.refresh = function(customEmailId) {
            vm.loading = true;
            RGSenderConfigService.refreshConfig(customEmailId).then(initConfig);
          };

          vm.close = function(){
            $uibModalInstance.close('cancel');
          }

          vm.save = function() {
            if (!vm.deliveryConfigForm.$valid) {
              return;
            }
            if (!angular.equals(vm.securityDefaults, vm.config.securityDefaults)) {
              RGSenderConfigService.updateSecurity(vm.securityDefaults).then(initConfig);
            }
          }

          vm.clearForms = function() {
            vm.editingCustomerEmailId = null
            vm.deletingCustomerEmailId = null
          }

          vm.addCustomSenderAddress = function() {
            if (!vm.customSenderForm.$valid) {
              return;
            }
            vm.isFormVisible = false
            vm.customSenderEmailAddresses.push({ fromEmailAddress: vm.newFromAddress, senderName: vm.newSenderName});
            RGSenderConfigService.addCustomEmailSender(vm.newFromAddress, vm.newSenderName).then(initConfig);
            vm.recentlyAddedAddress = vm.newFromAddress
          }

          vm.editDefaultSenderName = function() {
            if (vm.editingDefaultSenderName) {
              vm.editingDefaultSenderName = false
            }
            else {
              vm.updatedSenderName = vm.senderName
              vm.editingDefaultSenderName = true
            }
          }
          vm.updateDefaultSenderName = function() {
            vm.senderName = vm.updatedSenderName
            vm.editingDefaultSenderName = false
            RGSenderConfigService.updateDefaultSenderName(vm.senderName)
          }

          vm.showDeleteConfirmationForm = function(customerEmail) {
            if (vm.deletingCustomerEmailId == customerEmail._id.$oid) {
              vm.clearForms()
            }
            else {
              vm.clearForms()
              vm.deletingCustomerEmailId = customerEmail._id.$oid
            }
          }

          vm.editCustomEmailSenderName = function(customerEmail) {
            if (vm.editingCustomerEmailId == customerEmail._id.$oid) {
              vm.clearForms()
            }
            else {
              vm.clearForms()
              vm.editingCustomerEmailId = customerEmail._id.$oid
              vm.updatedCustomerEmailSenderName = customerEmail.senderName
            }
          }

          vm.isDeletingCustomEmailSenderName = function(customEmail) {
            if (vm.deletingCustomerEmailId && customEmail._id) {
              return vm.deletingCustomerEmailId == customEmail._id.$oid
            }
            else {
              return false
            }
          }

          vm.isEditingCustomEmailSenderName = function(customEmail) {
            if (vm.editingCustomerEmailId) {
              return vm.editingCustomerEmailId == customEmail._id.$oid
            }
            else {
              return false
            }
          }

          vm.updateCustomEmailSenderName = function(customerEmail) {
            customerEmail.senderName = vm.updatedCustomerEmailSenderName
            vm.editingCustomerEmailId = null
            RGSenderConfigService.updateCustomEmailSenderName(customerEmail._id.$oid, customerEmail.senderName )
          }

          vm.deleteCustomEmail = function(customEmailId) {
            vm.loading = true;
            vm.customSenderEmailAddresses = vm.customSenderEmailAddresses.filter(function(customEmail) {
              return customEmail._id.$oid != customEmailId
            })
            RGSenderConfigService.deleteCustomEmail(customEmailId).then(initConfig);

          }

          vm.showForm = () =>  {
            vm.isFormVisible = true
            $timeout(function() { angular.element("input#newFromAddress").focus() }, 200)
          }

          vm.hideForm = () => { vm.isFormVisible = false }

          vm.viewValidationDetails = (customEmail) => {
            vm.expandedEmail = customEmail
          }

          vm.isDetailsExpanded = (customEmail) => {
            if (vm.expandedEmail && customEmail._id) {
              return vm.expandedEmail == customEmail
            }
            else
              return false
          }

          vm.setEmailAsDefault = (email) => {
            vm.config.customSenderEmailAddresses.forEach((email) => email.isDefault = false)
            if (email) {
              email.isDefault = true
              vm.hasDefaultEmail = true
              RGSenderConfigService.markCustomEmailAsDefault(email._id.$oid).then(initConfig);
            }
            else {
              vm.hasDefaultEmail = false
              RGSenderConfigService.markCustomEmailAsDefault().then(initConfig);
            }
          }

          vm.onCancelPrivacyPolicyUrl = () => {
            vm.privacyPolicyUrl = vm.privacyPolicyUrlClean;
            vm.hideLocationText = vm.hideLocationTextClean;
            vm.customFooter = vm.customFooterClean;
            vm.emailSettingsForm.$setPristine();
          };

          vm.updateEmailSettings = (privacyPolicyUrl, hideLocationText, customFooter) => {
            RGSenderConfigService.updateEmailSettings(privacyPolicyUrl, hideLocationText, customFooter).then(initConfig);
          };


          vm.hideValidationDetails = () => { vm.expandedEmail = null }
        }],
        controllerAs: "vm",
        template: require("./accountSettingsModal.html"),
        size: 'lg'
      });
    }

    if(reactContainer && reactContainer.getContainer()) {
      const { setOpenAccountSettingsFn } = reactContainer.getContainer();
      if(setOpenAccountSettingsFn) {
        setOpenAccountSettingsFn(() => this.open);
      }
    }
  });
};
